import { z } from 'zod';
import { ConversationIdSchema } from '../ids.ts';
import { MessageFeedbackSchema } from './feedback.ts';

export const ConversationSchema = z.object({
  id: ConversationIdSchema,
  object: z.literal('conversation'),
  title: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  has_active_run: z.boolean(),
  unread: z.boolean(),
});
export type Conversation = z.infer<typeof ConversationSchema>;

export const ConversationDetailSchema = ConversationSchema.extend({
  messages: z.array(z.looseObject({ id: z.string(), role: z.enum(['user', 'assistant']) })),
  feedback: z.array(MessageFeedbackSchema).default([]),
});
export type ConversationDetail = z.infer<typeof ConversationDetailSchema>;

export const ConversationListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  after_id: ConversationIdSchema.optional(),
});
export type ConversationListQuery = z.infer<typeof ConversationListQuerySchema>;

export const ConversationListResponseSchema = z.object({
  data: z.array(ConversationSchema),
  has_more: z.boolean(),
  last_id: ConversationIdSchema.nullable(),
});
export type ConversationListResponse = z.infer<typeof ConversationListResponseSchema>;

export const ConversationDeletedSchema = z.object({
  id: ConversationIdSchema,
  object: z.literal('conversation.deleted'),
  deleted: z.literal(true),
});
export type ConversationDeleted = z.infer<typeof ConversationDeletedSchema>;
